import { Button } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layouts from "../components/Layouts";
import { counterAdd } from "../features/counter/counterSlice";
import { getConfig } from "../services/configuracion";
import { signoAdd } from "../features/signoMoneda/signoSlice";
import { fetchUserLoans } from "../features/prestamos/prestamoSlice";
import { omitir1Add } from "../features/omitir1/omitir1Slice";
import { dataRemotoAdd } from "../features/dataRemoto/dataRemoto";


function Home(props) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userdata?.id);
  const peticion = async () => {
    try {
      const response = await getConfig();
      dispatch(signoAdd(response));
      dispatch(omitir1Add(response.omitir_1));
      dispatch(dataRemotoAdd(response.data_remoto));
      dispatch(fetchUserLoans(user));
    } catch (error) {
      console.error("Error al obtener configuración:", error);
    }
  };

  useEffect(() => {
    peticion();
  }, []);
  return (
    <Layouts>
      <Button>Bienvenido</Button>
    
    </Layouts>
  );
}

export default Home;
